import { FieldValues, useController, UseControllerProps } from 'react-hook-form'
import ErrorMessage from '../ErrorMessage/ErrorMessage'
import styles from './Input.module.scss'

type InputProps = UseControllerProps<FieldValues> & {
  label?: string
  type?: string
}

const Input = ({ control, name, rules, label, type = 'text' }: InputProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({ control, name, rules })

  return (
    <div className={styles.container}>
      <input id={name} type={type} {...field} value={field.value || ''} placeholder=' ' className={error && styles.error} />
      <label htmlFor={name}>{label}</label>
      <ErrorMessage error={error} />
    </div>
  )
}

export default Input
